<template>
 <router-view></router-view>
 <notifications position="top right" />
</template>

<script>
// import './assets/css/index.css'
export default {
  name: 'App',
  components: {
  }
}
</script>
